import React from 'react';
import { Box, Typography } from '@mui/material';
import { TOKEN_COLOR } from './tokens';

const capSx = { fontSize: '11px', color: TOKEN_COLOR.textMuted };

// Small "27%" pill for a KPI card sub line.
export function PctChip({ value, total, color, bg }) {
    const pct = total > 0 ? Math.round((value / total) * 100) : 0;
    return (
        <Box component='span' sx={{
            display: 'inline-block', fontSize: '10.5px', fontWeight: 700, px: '7px', py: '1px',
            borderRadius: '10px', mr: '6px', color, bgcolor: bg,
        }}>
            {pct}%
        </Box>
    );
}

// Thin stacked bar under a KPI row with a legend and "a + b + … = total", so the cards visibly add up.
// segments: [{ key, label, value, color }]
export default function ShareBar({ segments = [], total }) {
    const sum = segments.reduce((s, x) => s + (x.value || 0), 0);
    const base = total ?? sum;
    return (
        <Box sx={{ mt: 1.5, mb: 2.5 }}>
            <Box sx={{ display: 'flex', height: 6, borderRadius: '4px', overflow: 'hidden', bgcolor: '#eceff1' }}>
                {base > 0 && segments.map((x) => (
                    <Box key={x.key} sx={{ width: `${((x.value || 0) / base) * 100}%`, bgcolor: x.color }} />
                ))}
            </Box>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '6px 18px', mt: 0.75 }}>
                {segments.map((x) => (
                    <Box key={x.key} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <Box sx={{ width: 8, height: 8, borderRadius: '2px', bgcolor: x.color }} />
                        <Typography sx={capSx}>{x.label} {x.value ?? 0}</Typography>
                    </Box>
                ))}
                <Typography sx={{ ...capSx, ml: 'auto', fontWeight: 600, color: '#555' }}>
                    {segments.map((x) => x.value || 0).join(' + ')} = {sum}
                </Typography>
            </Box>
        </Box>
    );
}
